(ns app.front.view.workspace.get
  (:require [app.front.entities :as entities]
            [app.front.view.workspace.subs :as ws-subs]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::get-workspace
  ;; note that this one does not perform :workspace/get-config automatically, so if you need config
  ;; entities such as party roles, fetch it separately
  (fn [{:keys [db]} [_ workspace-id & related-entities]]
    {:db           (-> db
                       (update-in [::state :fetching-workspace] #(conj (or % #{}) workspace-id)))
     :comm/command {:command    :workspace/get
                    :data       {:workspace/id workspace-id
                                 :find-related related-entities}
                    :on-success [::workspace-fetch-success workspace-id]
                    :on-done    [:notifications/add :toast :error :failure :dispatching/workspace-fetch-failure]}}))

(rf/reg-event-fx ::workspace-fetch-success
  (fn [{:keys [db]} [_ workspace-id status data]]
    {:db       (update-in db [::state :fetching-workspace] disj workspace-id)
     :dispatch [::entities/merge-entity-db status (:entities data)]}))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::fetching-workspaces
  :<- [::state]
  :-> ::fetching-workspace)

(rf/reg-sub ::fetching-workspace?
  :<- [::fetching-workspaces]
  (fn [fetching-workspaces [_ workspace-id]]
    (contains? fetching-workspaces workspace-id)))

(rf/reg-sub ::fetching-any-workspace?
  :<- [::fetching-workspaces]
  (fn [fetching-workspace _]
    (-> fetching-workspace seq boolean)))

(rf/reg-event-fx ::get-for-application-view
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :workspace/get
                    :data       {:workspace/id workspace-id
                                 :find-related [:entity.type/form
                                                :entity.type/acceptance
                                                :entity.type/attachment
                                                :entity.type/bim-attachment
                                                :entity.type/party
                                                :entity.type/requirement
                                                :entity.type/verdict
                                                :entity.type/inspection
                                                :entity.type/inspection-order
                                                :entity.type/order-template
                                                :entity.type/time-slot
                                                :entity.type/property
                                                :entity.type/order-acknowledgement
                                                :entity.type/invite
                                                :entity.type/review
                                                :entity.type/bill
                                                :entity.type/fee
                                                :entity.type/fee-group
                                                :entity.type/payment
                                                :entity.type/partial-occupancy
                                                :entity.type/group-config
                                                :entity.type/application-condition
                                                :entity.type/meeting
                                                :entity.type/phase-result
                                                :entity.type/planning-draft-report
                                                :entity.type/planning-final-report
                                                :entity.type/planning-uploaded-report
                                                :entity.type/agreement
                                                :entity.type/workspace
                                                :entity.type/council-decision
                                                :entity.type/archiving
                                                :entity.type/committee-meeting
                                                :entity.type/public-notice-document
                                                :entity.type/appeals-information
                                                :entity.type/checklist-topic
                                                :entity.type/case-note
                                                :entity.type/audit-event
                                                :entity.type/file
                                                :entity.type/complaint
                                                :entity.type/letter
                                                :entity.type/permit-type-config
                                                :entity.type/application-condition-template
                                                :entity.type/licence
                                                :entity.type/contractor-registration
                                                :entity.type/package-pdf
                                                :entity.type/approval
                                                :entity.type/public-notice-contact
                                                :entity.type/escrow-account
                                                :entity.type/property-attribute
                                                :entity.type/bond
                                                :entity.type/wizard-ai-rule-check-finding
                                                :entity.type/cloudcheck-run
                                                :entity.type/label-group]}
                    :on-success [:app.front.view.application/workspace-fetch-success workspace-id]
                    :on-done    [::ws-subs/workspace-fetch-fail]}}))

(rf/reg-sub ::fetching-config?
  :<- [::state]
  (fn [state [_ group-id]]
    (not= :done (get-in state [:config group-id]))))

(rf/reg-event-fx ::get-workspace-config
  (fn [{:keys [db]} [_ authority-group-id]]
    (when (not (contains? #{:fetching :done}
                          (get-in db [::state :config authority-group-id])))
      {:db           (-> db
                         (assoc-in [::state :config authority-group-id] :fetching))
       :comm/command {:command    :workspace/get-config
                      :method     :get
                      :data       {:group-id authority-group-id}
                      :on-success [::get-workspace-config.success authority-group-id]
                      :on-done    [::get-workspace-config.done authority-group-id]}})))

(rf/reg-event-fx ::get-workspace-config.success
  (fn [{:keys [db]} [_ group-id status resp]]
    {:dispatch [::entities/merge-entity-db status resp]
     :db       (-> db
                   ;; some places may crash if the entity is missing from entity-db -> update edb first before
                   ;; getting rid of the load indicators
                   (entities/merge-entity-db resp)
                   (assoc-in [::state :config group-id] :done))}))

(rf/reg-event-fx ::get-workspace-config.done
  (fn [{:keys [db]} [_ group-id _ _]]
    {:db (-> db
             (assoc-in [::state :config group-id] :failed))}))

(rf/reg-event-fx ::get-email-logs
  (fn [_ [_ workspace-id email-log-ids]]
    {:comm/command {:command    :workspace/email-log-entities
                    :data       {:workspace-id  workspace-id
                                 :email-log-ids email-log-ids}
                    :on-success [::entities/merge-entity-db]}}))
